import {ChangeDetectionStrategy, Component, inject} from '@angular/core';
import {Router} from '@angular/router';
import {Location} from '@angular/common';
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";

@Component({
    selector: 'app-unauthorized-dialog',
    templateUrl: './unauthorized-dialog.component.html',
    styleUrls: ['./unauthorized-dialog.component.sass'],
    standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UnauthorizedDialogComponent {
  dialogRef = inject(NgbActiveModal);
  router = inject(Router);
  location = inject(Location);

}
